import type { ReactNode } from "react";
import styles from "./Sidebar.module.css";

interface SidebarProps {
  children: ReactNode;
}

export function Sidebar({ children }: SidebarProps) {
  return <div className={styles.content}>{children}</div>;
}

interface TopProps {
  children: ReactNode;
}

function Top({ children }: TopProps) {
  return <nav className={styles.top}>{children}</nav>;
}

interface BottomProps {
  children: ReactNode;
}

function Bottom({ children }: BottomProps) {
  return <nav className={styles.bottom}>{children}</nav>;
}

interface UserProps {
  avatar?: ReactNode;
  name: string;
  role?: string;
  onSignOut: () => void;
  signOutLabel?: string;
  "data-testid"?: string;
}

function User({
  avatar,
  name,
  role,
  onSignOut,
  signOutLabel = "Logg ut",
  "data-testid": testId,
}: UserProps) {
  return (
    <div className={styles.user}>
      <div className={styles.identity}>
        {avatar ? <div className={styles.avatar}>{avatar}</div> : null}
        <div className={styles.identityText}>
          <div className={styles.name}>{name}</div>
          {role ? <div className={styles.role}>{role}</div> : null}
        </div>
      </div>
      <button
        type="button"
        className={styles.signOut}
        onClick={onSignOut}
        data-testid={testId}
      >
        {signOutLabel}
      </button>
    </div>
  );
}

Sidebar.Top = Top;
Sidebar.Bottom = Bottom;
Sidebar.User = User;
